
import React from "react";
import Base from "../core/Base";
import {Link} from "react-router-dom";

const PageNotFound = () => {
    return (
        <Base>
            <section className="error-area">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container">
                            <div className="error-content">
                                <h1>404 !</h1>
                                <p>This Page Cannot Be Found !</p>
                                <Link to='/' className="btn btn-primary">Home</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Base>
    );
};

export default PageNotFound;
